const imageServerWhitelist = [
    'images.unsplash.com',
    'cdn.pixabay.com',
    'storage.googleapis.com',
    'firebasestorage.googleapis.com',
    'pixabay.com',
    'assets-staging.cdn.msgsndr.com',
    'staging.cdn.msgsndr.com',
    'staging.filesafe.space',
    'default.staging.filesafe.space',
    'assets.cdn.msgsndr.com',
    'cdn.msgsndr.com',
    'cdn.filesafe.space',
    'assets.cdn.filesafe.space',
    'img.youtube.com',
    'i.vimeocdn.com',
    'embed-ssl.wistia.com',
    'widgets.leadconnectorhq.com',
];
const evn = process.env.mode || 'development';
const appConfig = {
    development: {
        // baseURL: 'https://staging.services.leadconnectorhq.com',
        baseURL: 'http://localhost:5074',
        PIXABAY_API: 'https://pixabay.com/api/',
        UNSPLASH_API: 'https://api.unsplash.com/search/photos',
        PIXABAY_KEYS: [
            '12837777-0e1eefc6cf67960383fd3be03',
            '24254034-52abe6cce2e2ce57de970cc18',
            '24254138-ccbe31ce64d739403099440b8',
            '24254176-41254053956a7721b65efde19',
            '24254208-6d416619eb4cb2fa75f01c30a',
        ],
        UNSPLASH_CLIENT_IDS: [
            'xvwHvFoRM9N4QWF6_d2Bo2zASXbVJEh7RbMRZi_O3F8',
            't2JHt_hm3j9DUqkgH25VHgOMI1tFJ6VgC0w6l382PsM',
            'uhoo1DxbALgaEZe12cq0B9FAr7bJShLcmCl1zVcImmA',
            'OFnXz4f93z9OB3rZxFEBBJXIDZomWIfvuzeOd7MkBxQ',
            'kmxB1VpcVyJpUhHg60Z0jVNGU12zbTpyL9SP4TkYAc0',
            'biS79nd2alJaZ4s1XIGgrtz2dWt5i-J_vOAc4tQt2oo',
            'Im2sUn8UVXDqcJoB0J1pD0VnIi_iGbZja-7zz35QxzA',
            'xjyboOf2BHJz1d1HACeTDKIoPjrSazc5TL-X0JzzrlE',
            'QSzXCnHT2efz389rCetd2ugTFY400tGW2W0MuGSY8kw',
            'y9jO-HdFjMANPmpAbu9R63vXcgGHvdML-x-LngFTlFw',
        ],
        imageServer: 'https://images-staging.leadconnectorhq.com',
    },
    staging: {
        baseURL: 'https://staging.services.leadconnectorhq.com',
        PIXABAY_API: 'https://pixabay.com/api/',
        UNSPLASH_API: 'https://api.unsplash.com/search/photos',
        PIXABAY_KEYS: [
            '12837777-0e1eefc6cf67960383fd3be03',
            '24254034-52abe6cce2e2ce57de970cc18',
            '24254138-ccbe31ce64d739403099440b8',
            '24254176-41254053956a7721b65efde19',
            '24254208-6d416619eb4cb2fa75f01c30a',
        ],
        UNSPLASH_CLIENT_IDS: [
            'xvwHvFoRM9N4QWF6_d2Bo2zASXbVJEh7RbMRZi_O3F8',
            't2JHt_hm3j9DUqkgH25VHgOMI1tFJ6VgC0w6l382PsM',
            'uhoo1DxbALgaEZe12cq0B9FAr7bJShLcmCl1zVcImmA',
            'OFnXz4f93z9OB3rZxFEBBJXIDZomWIfvuzeOd7MkBxQ',
            'kmxB1VpcVyJpUhHg60Z0jVNGU12zbTpyL9SP4TkYAc0',
            'biS79nd2alJaZ4s1XIGgrtz2dWt5i-J_vOAc4tQt2oo',
            'Im2sUn8UVXDqcJoB0J1pD0VnIi_iGbZja-7zz35QxzA',
            'xjyboOf2BHJz1d1HACeTDKIoPjrSazc5TL-X0JzzrlE',
            'QSzXCnHT2efz389rCetd2ugTFY400tGW2W0MuGSY8kw',
            'y9jO-HdFjMANPmpAbu9R63vXcgGHvdML-x-LngFTlFw',
        ],
        imageServer: 'https://images-staging.leadconnectorhq.com',
    },
    production: {
        baseURL: 'https://services.leadconnectorhq.com',
        PIXABAY_API: 'https://pixabay.com/api/',
        UNSPLASH_API: 'https://api.unsplash.com/search/photos',
        PIXABAY_KEYS: [
            '12837777-0e1eefc6cf67960383fd3be03',
            '24254034-52abe6cce2e2ce57de970cc18',
            '24254138-ccbe31ce64d739403099440b8',
            '24254176-41254053956a7721b65efde19',
            '24254208-6d416619eb4cb2fa75f01c30a',
        ],
        UNSPLASH_CLIENT_IDS: [
            'b-JDTNRbiPuTx1GZkzXkM7GtP16R4O9RNWkFySuLQYQ',
            'DN39Fiawl7y_iDAlCZKrhDomB_6MTTNF8agocpWER-8',
            'i-64jZrehgRsPC3qqQqYImoVMbFxCvGHTP0QHi2yG-Q',
            'LWygqJvJEy6MSOEAR5Ln8eKW8q-sPEN2xZwforLR0jQ',
            'iKRnC8FaDhpdc1ibb6OiQKb33XxDAQjbCIMc1CMRkoY',
            'w_-7Aej1crpt8lvJghN9D35gYbU4MaKBgiGkJTifbP0',
            '9nMIWliyoseHr_lG44caGXWP8S1kAZjajqGu1j3yuPY',
            'afcwDLpr3rCO4YMmpugW6c1zJ-NkzTxNKtamGfNDUbk',
            'qjXwwSebAGO6h-LMbRngQ9MMVIlcOwMY9GUVxQAP7_Y',
            'OHlJssrQYZDm3gHYipAGOq24YsMS8PN0RSb03BlTOIs',
            'OZ1QdxYzi9gj7wyGWUJOny9rRVOyCQeKVFfd9Op2v7M',
        ],
        imageServer: 'https://images.leadconnectorhq.com',
    },
};
export default Object.assign(Object.assign({}, appConfig[evn]), { imageServerWhitelist });
